var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocumentIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#0E0E0E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M29.333 13.333V20c0 6.667-2.666 9.333-9.333 9.333h-8c-6.667 0-9.333-2.666-9.333-9.333v-8c0-6.667 2.666-9.333 9.333-9.333h6.667"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0E0E0E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M29.333 13.333H24c-4 0-5.333-1.333-5.333-5.333V2.667zm-20 4h8m-8 5.334h5.334"
})));
export default SvgDocumentIcon;